import { CompanyLegalNameUpdateReason, DocumentExtensionEnum, LOBType, LOBTypeFullName, RenewalGroups } from "./_enum/module.enum"

export const PRODUCT_CONFIG = {
    LongCommonTextEllipsis: 64,
    ProducerNameEllipsis: 24,
    IdleDialogSeconds:120,
    IdleTimeoutSeconds:7080,
    autoRefreshTokenMiliSeconds: 3600000,
    DiceEffectiveDateRange: 60,
    MaxFileUploadSize: 20971520,
    typeaheadTypeLength: 3,
    businessLookupTypeLength: 6,
    SubmissionEffectiveDateRange: 90,    
    zipMaxlength: 10,
    phoneMaxlength: 13,
    feinMaxlength: 10,
    nameMaxlength: 50,
    addressMaxlength: 60,
    extraDetailsMaxlength: 100,
    officerNamesMaxlength: 80,
    officerShortMaxlength: 5,
    officerOwnershipMaxlength: 10,
    companyDetailsMaxlength: 254,
    companyNameMinLength: 3,
    notesMaxLength: 2000,
    maxDnbExpectedResultCount: 10,
    DaysUntilPasswordExpiration: 7
}

export const POLLING_CONFIG = {
    PollingInterval : 5000,
    MaxPollingAttempt: 65,
    MfaPollingInterval: 1000,
    MfaMaxPollingAttempt: 300,
    MfaQRMaxPollingAttempt: 600
}

export const ENDORSEMENT_CONFIG = {
    MaxUploadSize: 20971520  /** 20 MB */
}

export const FILE_UPLOAD_CONFIG = {
    MaxUploadSize: 20971520,  /** 20 MB */
    FileNameEllipsis: 35,
    SmallFileNameEllipsis: 24,
    MediumFileNameEllipsis: 50,
    LongFileNameEllipsis: 75,
    AttachmentNoContent: "Upload failed. Please check the file(s) and try again.",
    AttachmentExceeds: "Attachment exceeds max upload size",
}

export const ANNOUNCEMENT_CONFIG = {
    BannerTitle: "Coaction becomes first commercial P&C insurance company to obtain a certified B Corporation designation:",
    BannerDesc: "Learn more by reading the press release",
    BannerLink: "here",
    BannerLinkUrl: "https://www.coactionspecialty.com/in-the-news/press-release/coaction-achieves-b-corp-certification/",
    ModalTitle: "Coming Soon: Two-Step Verification",
    ModalDesc: "On September 10th, Coaction Partner Portal will enable 2-Step Verification to protect your account with both your password and your phone or email. Adding 2-Step Verification can help keep online attackers out, even if they have your password. When signing in to Coaction Partner Portal, you'll enter your password as usual. Then, you will have the option to receive a one-time code via email, text message, or by downloading the OKTA app.",
    ModalFooter: "For more information, visit our",
    ModalLink: "FAQs",
}

export const FORM_MSGS = {
    ValidUsernamePassword: "Enter a valid username and password to continue.",
    UsernameNotFound: "That username isn't associated to an account.",
    RequestToResetPasswordSent: "Your request to reset your password has been sent.",
    SomethingWentWrong: "Something went wrong! Please try again later.",
    PasswordHasBeenReset: "Your password has been reset.",
    IncorrectCurrentPassword: "Current password is incorrect.",
    SessionTimeout: "You have been logged out due to inactivity.",
    PasswordChanged: "Your password has been updated.",
    ForgotPasswordInstruction: "Enter your email address below and we'll send you password reset instructions",
    ProsightAccountPasswordReset: "You cannot reset your Coaction Account password here",
    ValidEmailRequired: "Valid email address is required",
    NewPasswordRequired: "New password is required",
    RepeatPasswordRequired: "Repeat password is required",
    NewPasswordFollowRules: "New password does not meet requirements",
    PasswordDoNotMatch: "Passwords do not match",  
    PasswordContainsName: "Password contains first or last name",  
    PasswordTooRecent: "Password has been used too recently",  
    OldPasswordIncorrect: "Old Password is not correct",  

    ValidPhoneFormatRequired: "Valid phone number is required",
    ValidPolicyOrClaimRequired: "Valid Policy or Claim # is required",

    PasswordInstruction_1: "At least 8 characters",
    PasswordInstruction_2: "A lower case letter",
    PasswordInstruction_3: "An upper case letter",
    PasswordInstruction_4: 'A number (0-9)',
    PasswordInstruction_5: 'A symbol (eg. !@#$%^&*)',
    PasswordInstruction_6: 'Your first or last name',
    PasswordInstruction_7: 'Your previous 5 passwords',

    OktaAutheticationErrorMsg: "Update of credentials failed",

    PleaseTryAgain: "Please try again later.",
    
    AddressNotFound: 'We were unable to locate the address you entered. If it looks incorrect, you can go back to edit',

    EffectiveToday: "Your selection for same day coverage begins at 12:01AM and you hereby warrant no losses have occurred from 12:01AM to present time",

    DiscardModal: {
        title: "Are You Sure?",
        text: "Any information you've entered will not be saved or submitted."
    },
}

export const MFA_MSGS = {
    SetUpTitle: "Set Up",
    UpdateTitle: "Two-Step Verification",
    SelectVerificationLabel: "Select a verification method to continue",
    UpdateVerificationLabel: "Select a verification method to update",
    TextSentDesc: "For added security, we’ve texted you a single-use Verification Code to the mobile phone number on file.",
    EmailSentDesc: "For added security, we’ve emailed you a single-use Verification Code to the email address on file.",
    AuthCodeRequired: "Verification code is required",
    MfaInvalidTotp: "Please enter a valid verification code",
    OktaTryAgainText: "An SMS message was recently sent. Please wait 30 seconds before trying again.",
    OktaTryAgainEmail: "An email was recently sent. Please wait 5 seconds before trying again.",
    OktaTryAgainMsg: "A new code was recently sent. Please wait 30 seconds before trying again.",
    CodeSentSuccess: "Your new code has been sent.",
    InvalidTOTP: "Invalid TOTP"
}

export const ENDORSEMENT_MSGS = {
    ValidEffectiveDateRequired: "Effective date is required",
    EndorsementTypeRequired: "At least one selected endorsement type is required",
    SubmissionMethodRequired: "Submission method is required",
    RequestTypeRequired: "Request type is required",
    SummaryRequired: "Summary is required",
    DocumentRequired: "You must attach additional documents to continue.",
    FileTypeRequired: "File type is required",

    UserRequestEndorsementButton: "Use the “Request Endorsement” button to get started.",
    PolicyNoLongerBeEndorsed: "This policy can no longer be endorsed.",
    
    FieldIsRequired: "This field is required",
    InvalidField: "Invalid input",
}

export const SUBMISSION_MSGS = {
    NoSubmissionsFound: "You don’t have any Submissions",
    UserNewBusinessButton: 'Use the "Submit New Business" button to get started.',
    FieldIsRequired: "This field is required",
    CoverageTypeRequired: "At least one Coverage is required",
    FeinNo: 'Enter a valid FEIN #',
    SICCodeRequired: "Select at least one SIC Code",
    SICCodePercent100: "Total percentage does not equal 100.",
    SICCodePercent0: "SIC Code percentage cannot be 0.",
    NoCodesFound: "No codes found that match your search.",
    SelectEffectiveExpirationDate: "Select a Policy Effective Date to determine available coverages.",
    NoCoverageAvailable: "No coverage is available for the selected Policy Effective Date.",
    DocumentsRequired: "You must attach additional documents to continue.",
    SubmittedTitle: "Your submission request has been submitted to your underwriter.",
    SubmittedDesc: "The information you provided has been sent to your underwriter. Your underwriter has been notified.",
    ReferredTitle: "Your submission request has been referred to your underwriter for further review.",
    ReferredDesc: "We need to take a closer look before we can provide an update. Your underwriter has been notified.",
    BlockedTitle: "Your submission request has been blocked.",
    BlockedDesc: "The account is blocked and not available. Your underwriter has been notified.",
    completedOnlineSupplemental: "Insured completed Coaction's Online Supplemental",
    specifyRequest: "Specify requested Lines of Business in “Additional Notes” below",
    SomethingWentWrong: "There was a problem loading Submissions",
    CharacterLimitReached: "Character limit reached",

    ClearAccountFailure: {
        title: "Something Went Wrong",
        text1: "There was a problem validating the Company Legal Name you've entered.", 
        text2: "Go back to make sure you've entered the information correctly. If it appears correct and the problem persists, contact"
    }
}

export const RENEWAL_MSGS = {
    FieldIsRequired: "This field is required",
    DocumentRequired: "You must attach additional documents to continue.",
    AtLeastOneOptionRequired: "At least one option is reqiured",
    AnnualGPCRequired: "Estimated Annual GPC is required",
    AnnualGPCValid: "Estimated Annual GPC should be minimum 50,000",
    YearGPCRequired: "Expiring Year GPC is required",
    YearGPCValid: "Expiring Year GPC should be minimum 50,000",
    OneMediaTypeRequired: "At least one Media Type is required",
    documentNotSelected: 'You must attach a Waiver to continue',
    certifyCheck: 'You must certify that the Waiver is signed and completed',
    noOfEmp: 'Number of employees is required',

    DiscardModal: {
        title: "Cancel Request",
        text: "Are you sure you want to cancel? This will discard your request and can’t be undone. "
    }
}

export const RESULTS_NOT_FOUND = {
    NoResultsFound: "No Results Found",
    SearchNoResults: "We couldn’t find anything that matched your search. Be sure you’ve entered it correctly or try browsing through the navigation above.",
    NoMessagesFound: "There was an error loading Recent Messages",
    FoundNothingForYou:"We couldn’t find anything for you.",
    NoAdjusterTitle: "No Adjusters Found",
    NoAdjusterFound: "This claim has not been assigned any adjusters.",
    NoNotesTitle: "No Notes Found",
    NoNotesFound:"There aren’t any notes on this claim.",
    NoAccountsFound: "There aren’t any accounts to show.",
    NoPoliciesFound: "There aren’t any policies to show.",
    NoClaimsFound: "There aren’t any claims to show.",
    NoPaymentsFound: "There aren’t any payments to show.",
    NoDocumentsFound: "No Documents Found",
    NoPendingCancellation: "There are no Pending Cancellations to show.",
    NoDirectBillFoundForAccount: "There aren’t any Direct Bill policies associated to this account",
    NoNoticesFoundTitle: "No Notices Found for this policy",
    NoEndorsementsFound: "You Have No Online Endorsement Requests",
    NotBOR: "You no longer have access to this information.",
    policyDetailsEffectiveDate: 'The Effective Date has passed. Choose a new date',
    NoOpenQuotesTitle: "You don’t have any Open Quotes",
    NoOpenQuotesDetail: "Use the “Submit New Business” button to get started.",
    NoClosedQuotesTitle: "You don’t have any Closed Quotes",
    NoIssuedQuotesTitle: "You don’t have any Issued Quotes",
    NoMRPolicyFound: "There aren’t any Monthly Reporter Policy to show.",
    NoInstallmentPlanPolicyFound: "There aren’t any Installment Plan to show.",
    NoAccountActivityFound: "There isn't any activity to show.",
    RefineYourSearch: "You can refine your search using the options provided. Documents created before 6/1/2021 will not be available online.",
    SomethingWentWrong: "Something Went Wrong",
    TryAgain: "Try searching again using the options provided.",
    NoRenewalsFound: "No accounts have upcoming renewals.",
    CannotEdit: "You cannot edit User who is not Active or Pending.",
    NoUserFound: "No User Found",
    NoCompanyFound: "No Company Found",
};

export const DICE_QUOTES_CONFIG = {
    MaxDateSelectionForQuote: 60,   // Max number days for selecting quote date
    QuoteDays: 30,                   // Extra days to copy quote after policy effective date
    InputMaxChars: 254,
    FormErrorMessages: {
        companyLegalName: 'Company Legal name is required',
        dbaName: 'DBA Name has a maximum of 254 characters',
        companyLegalEntity: 'Company Legal Entity is required',
        feinNo: 'Enter a valid FEIN #',
        website: 'Enter a valid website',
        sicCodePercent100: "Total percentage does not equal 100.",

        streetAddress: 'Street Address is required',
        streetAddress2: '',
        city: 'City is required',
        state: 'State is required',
        zipcode: 'Zip Code is required',
        addressValidation: 'You must verify address to continue',

        name: 'Enter both First and Last Name',
        emailAddress: 'Enter a valid Email Address',
        phoneNumber: 'Enter a valid Phone Number',

        underwritingQuestions: 'This question is required',
        underwritingActivities: 'Please select at least one activity',

        policyEffectiveDate: 'Enter a valid Policy Effective Date',
        estimatedAnnualGPC: 'Estimated Annual GPC is required',
        estimatedAnnualGPCLessThan0: 'Estimated Annual GPC must be greater than $0',
        expiringYearGPC: 'Expiring Year GPC is required',
        expiringYearGPCLessThan0: 'Expiring Year GPC must be greater than or equal to $0',

        mediaType: 'At least one Media Type is required',
        glLimits: 'Limits are required',
        medicalLimit: 'Select a Medical Expense Limit',

        responseRequired: 'Your response is required',
        costOfHire: 'Cost of Hire is required (minimum is $100)',
        noOfEmployees: 'Number of employees is required',
        noOfEmployeesLessThan0: 'Number of employees must be greater than 0',

        umbrellaLimit: 'Limit is required',

        monopolisticState: 'Please enter a zip code which is not in one of the following monopolistic states - ND, OH, WA, WY',
        stateOfHire: 'Select a State of Hire',
        classCode: 'Select a Class Code',
        otherClassCode: 'Enter a valid class code',
        predefinedCode: 'Please enter other class code as this class code is already added for the above location',
        payroll: 'Payroll Type is required',
        payrollAmount: 'Payroll Amount is required',
        nonZeroPayroll: 'Please enter non-zero payroll amount for at least one class code',
        partTimeEmp: 'Part-Time Employees is required',
        fullTimeEmp: 'Full-Time Employees is required',
        totalEmpLessThan0: 'Total number of employees must be greater than 0',

        personsRole: 'Persons is required',

        attachmentDocTypes: 'Please select document type(s) for all attachments',

        billingType: 'Billing Type is required',
        billingPaymentType: 'Please select payment type',
        passedEffectiveDate: 'The Effective Date has passed. Choose a new date',

        officerRequired: 'You must select Excluded and/or Included Officers',
        excludedOfficer: 'Excluded Officer Name is required',
        includedOfficer: 'Included Officer Name is required',

        certifyUMUIM: 'I certify that the uploaded document is a signed and completed UM/UIM coverage selection form.',
        certifyNotCheckedUMUIM: 'You must certify that the Form is signed and completed',

        certifyTria: 'I certify that the uploaded document is a signed and completed TRIA Waiver form.',
        certifyTriaPlural: 'I certify that the uploaded documents are signed and completed TRIA Waiver forms.',
        certifyNotChecked: 'You must certify that the Waiver is signed and completed',
        certifyNotCheckedPlural: 'You must certify that the Waivers are signed and completed',
        formNotAttached: 'You must attach a form to continue',

        acceptAcknowledgement: "You must accept the Terms and Conditions",
        understandAcknowledgement: "You must acknowledge this to continue",
        COIRequired: "You must attach a Certificate of Insurance to continue",

        auWosIncluded: "Includes Waiver of Subrogation & Additional Insureds at no charge",
        auWosExcluded: "Includes Additional Insureds at no charge",

        uwReferral: "Note: Selection will trigger an underwriting referral",
        uwLimitReferral: "Note: Selected limit will trigger an underwriting referral"
    },
    Address: {
        Verified: 'Verified',
        Overridden: 'Overridden'
    },
    AccountStatus: {
        Available: "Available",
        Referred: 'Referred to Underwriting',
        NotAvailable: "Not Available",
        Issued: null
    },
    QuoteStatus: {
        Referred: "Referred to Underwriting",
        Expired: "Expired",
        Blocked: "Blocked",
        Quoted: "Quoted",
        Issued: "Issued",
        Bound: "Bound",
        NotTaken: "Not Taken",
        New: "New"
    },
    LobStatus: {
        Referred: "Referred to Underwriting",
        Offline: "Offline Processing",
        Expired: "Expired",
        Blocked: "Blocked",
        Quoted: "Quoted",
        Issued: "Issued",
        New: "New"
    },
    QuoteMessages: {
        Issued: {
            title: 'Your quote has been created. It’s valid until 11:59pm on its effective date.',
            text: 'All premiums and fees are subject to change until the time of issuance. The insured may be subject to installment fees, depending on their State. To waive TRIA coverage, provide a signed TRIA waiver when you issue.'
        },
        Referred: {
            title: 'This quote has been referred to underwriting.',
            text: 'Our team will need to take a closer look before we can provide a quote. We’ll be in touch within 48 hours to move things forward.'
        },
        ReferredShort: {
            title: '', //no title needed
            text: 'This quote has been referred to your underwriter, we will be in touch shortly.'
        },
        Blocked: {
            title: 'This account is blocked.',
            text: 'The account may have already been submitted by another broker. We’ll be in touch within 48 hours to move things forward.'
        },
        Expired: {
            title: 'This quote has expired.',
            text: 'This quote has expired as it’s past its effective date. To create a new quote for this account, use the "Copy Quote" button and request a new quote with an updated effective date.'
        },
        Bind: {
            title: 'Complete this form to issue the quoted policies.',
            text: 'Continue to automatically issue policies for the quoted lines of business.'
        },
        RateChanged: {
            title: 'The quoted price has changed. Review the current price.',
            text: 'Rates change for a number of reasons to improve accuracy. Review the change, then continue to issue.'
        },
        RateConfirmed: {
            title: 'Your quoted price has been confirmed.',
            text: 'We’ve confirmed your quote and are ready to issue.'
        },
        PolicyIssued: {
            title: 'The policy has been successfully issued.',
            text: 'The policy is now issued in our system and will be in-force on the specified effective date.'
        },
        PolicyReferred: {
            title: 'There was a problem issuing the policy.',
            text: 'Something went wrong and we cannot issue this policy online. We’ll be in touch within 48 hours to move things forward. '
        }, 
        OfflineProcessingLong: {
            title: '', //no title needed
            text: 'Coverage will be issued separately by our Underwriting team. If you make any changes to your quote, make sure you communicate the changes to Underwriting.'
        },
        OfflineProcessing: {
            title: '', //no title needed
            text: 'Coverage will be issued separately by our Underwriting team.'
        }
    },
    ModalMessages: {
        DiceModal: {
            boldText: "This may take up to 3 minutes.",
            modalText: "We’ll automatically reload this screen with the details once it’s complete.",
            warningText: "Do not go back or close this window until completed."
        },
        ChangeAccount: {
            title: "Change Account",
            text: "Are you sure that you want to change the account? This will reset any information you’ve entered."
        },
        ClearAccountFailure: {
            title: "Something Went Wrong",
            text1: "There was a problem validating the Company Legal Name you've entered.", 
            text2: "Go back to make sure you've entered the information correctly. If it appears correct and the problem persists, contact"
        }
    },
    Officers: {
        Officers: {
            caption: 'Officer',
            fullCaption: 'Officers/Directors',
            field: 'Name of Officers'
        },
        Partners: {
            caption: 'Partners',
            field: 'Name of Partners'
        },
        Others: {
            caption: 'Others',
            field: 'Name of Others'
        },
        SoleProprietor: {
            caption: 'Sole Proprietor',
            field: 'Name of Sole Proprietor'
        },
        Employees: {
            caption: 'Employees',
            field: 'Name of Employees'
        },
        ProfessionalCorporation: {
            caption: 'Professional Corporation',
            field: 'Name of Professional Corporation'
        },
        Title: {
            field: 'Title / Relationship'
        },
        Ownership: {
            field: 'Ownership Percentage'
        },
        ShortenedTitle: {
            field: 'Shortened Titles of Officers Excluded'
        },
        LLC: {
            caption: 'Limited Liability Company',
            field: 'Name of Managing Members / Trustees'
        },
        PSLC: {
            caption: 'Professional Service Liability Company',
            field: 'Name of Professional Service Liability Company'
        },
        RLLP: {
            caption: 'Registered Limited Liability Partnership',
            field: 'Name of Registered Limited Liability Partnership'
        },
    },
    SpecificStates: {
        HI: {
            stateLabel: 'HI - Hawaii',
            fields:[{
                required: true,
                maxlength: 10, 
                field: 'HIDeptLaborNumber'
            }]
        },
        ME: {
            stateLabel: 'ME - Maine',
            fields: [{
                required: true,
                maxlength: 10, 
                field: 'MEUnemploymentNumber'
            }]
        },
        UT: {
            stateLabel: 'UT - Utah',
            fields: [{
                required: true,
                maxlength: 10, 
                field: 'UTUnemploymentNumber'
            }]
        },
        RI: {
            stateLabel: 'RI - Rhode Island',
            fields: [{
                required: true,
                maxlength: 10, 
                field: 'RIUnemploymentNumber'
            }]
        },
        MN: {
            stateLabel: 'MN - Minnesota',
            fields: [{
                required: true,
                maxlength: 12, 
                field: 'MNUnemploymentNumber'
            },
            {
                required: true,
                maxlength: 7, 
                field: 'MNAssociationNumber'
            },
            {
                required: false,
                maxlength: null, 
                field: 'MNExempt'
            }]
        }
    }
};

export const ADMIN_UTILITY = { 
    UserAccountCreatedSuccessfully: "Your account has been created successfully.",
    UserAccountActivatedSuccessfully: "Your account has been activated successfully.",
    UserAccountActivated_Login: "User account is already active. Login or reset password below.",
    UserAccountDeactivated: "User account is deactivated. Contact support below.",
    UserAccountExpired: "Your activation link has expired. Contact support below.",
    UserAccountExist: "User account already exists.",
    UserAccountNotFound: "We are unable to locate your profile.",

    FirstNameRequired: "First name is required",
    LastNameRequired: "Last name is required",
    ProducerCodeRequired: "Producer Code is required",
    ValidPhoneFormatRequired: "Valid phone number is required",

    CompanyCreatedSuccessfully: "This company has been created successfully.",
    CompanyExist: "This company profile already exists.",

    CompanyNameRequired: "Company Name is required",

    DiceCommissionsRequired: "All DICE Commissions are required",
    DiceUWNameRequired: "Underwriter name is required",
    AdminConfigError: "Unable To Load Confg Info from DB",

    CompanyNameEllipsis: 30,

    NameMaxlength: 25,
    EmailMaxlength: 50,
    CompanyNameMaxlength: 150,
    NoteMaxlength: 250
}

export const PROFILE_OPTIONS = [
    {
        id:1,
        displayName: "Policies",
        moduleName: "Policies",
        default: true,
        isSelected: true,
        /* children: [{
            id:2,
            displayName: "Loss Run Report",
            moduleName: "BulkLossRun",
            default: true,
            isSelected: true,
        }] */
    },
    {
        id:2,
        displayName: "Claims",
        moduleName: "Claims",
        default: true,
        isSelected: true,
        children: [{
            id:3,
            displayName: "Claim Notes",
            moduleName: "ClaimsNotes",
            default: true,
            isSelected: true,
        }]
    },
    {
        id:4,
        displayName: "Reports",
        moduleName: "Reports",
        default: true,
        isSelected: true,
        children: [{
            id:5,
            displayName: "Claim Acknowledgement Report",
            moduleName: "ClaimsAcknowledgementReport",
            default: true,
            isSelected: true,
        }]
    },
    /* {
        id:6,
        displayName: "DICE",
        moduleName: "DICEQuoting",
        default: false,
        isSelected: false,
    },
    {
        id:7,
        displayName: "Mobile Incidents",
        moduleName: "MobileIncidents",
        default: false,
        isSelected: false,
    } */
]

export const POLICY_DOCUMENTS_NAME = [
    {
        id: 0,
        displayName: "All Documents",
        type: "",
        documentTypes: ["Audit Statement", "Cancellation Packet",  "Carrier Cancellation Notice", "Endorsement Packet", "Endorsement Request", "MOI", "Policy", "Policy Reissue", "Reinstatement Packet", "Rescission Notice"],
        isSelected: false
    },
    {
        id: 1,
        displayName: "Audit Statement",
        type: "Audit Statement",
        documentTypes: ["Audit Statement"],
        isSelected: false
    },
    {
        id: 2,
        displayName: "Cancellation Packet",
        type: "Cancellation Packet",
        documentTypes : ["Cancellation Packet"],
        isSelected: false
    },
    {
        id: 3,
        displayName: "Endorsement Packet",
        type: "Endorsement Packet",
        documentTypes : ["Endorsement Packet", "Endorsement Request"],
        isSelected: false
    },
    {
        id: 4,
        displayName: "Notice of Cancellation",
        type: "Carrier Cancellation Notice",
        documentTypes : ["Carrier Cancellation Notice"],
        isSelected: false
    },
    {
        id: 5,
        displayName: "Policy Packet",
        type: "Insured Copy",
        documentTypes : ["Policy", "Policy Reissue", "MOI"],
        isSelected: false
    },
    {
        id: 6,
        displayName: "Reinstatement Packet",
        type: "Reinstatement Packet",
        documentTypes : ["Reinstatement Packet"],
        isSelected: false
    },
    {
        id: 7,
        displayName: "Rescission Notice",
        type: "Rescission Notice",
        documentTypes : ["Rescission Notice"],
        isSelected: false
    }
]

export const MFA_FACTORS = [
    {
        id: 0,
        title: "Verify via Text Message",
        desc: "A single-use code will be sent via text message to your mobile phone.",
        type: "sms",
        status: "",
        factorID: "",
        image: "text-icon",
        isPreferred: false,
        isSelected: false
    },
    {
        id: 1,
        title: "Verify via Email",
        desc: "A single-use code will be sent to your email address.",
        type: "email",
        status: "",
        factorID: "",
        image: "email-icon",
        isPreferred: false,
        isSelected: false
    },
    {
        id: 2,
        title: "Verify via Okta Verify App",
        desc: "A push notification will be sent to your mobile app.",
        type: "push",
        status: "",
        factorID: "",
        image: "phone-icon",
        isPreferred: false,
        isSelected: false
    },
    {
        id: 3,
        title: "Verify via Okta Verify App",
        desc: "A push notification will be sent to your mobile app.",
        type: "token:software:totp",
        status: "",
        factorID: "",
        isPreferred: false,
        isSelected: false
    }
]

export const IMAGES = {
    adjusterImage: "iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUdwTP////////////////////////P09f///////////////yEzQjZHVIqTm+Pm6FhmccfM0HR/iayzuJ6mrEpZZWZzfbq/xNXZ3HdQWMYAAAALdFJOUwC3bxBfz5X93yBAPxcN+wAABHRJREFUeNrlm4tuqzAMQGm7NnTBeSfw/196gcIKbfMikFS6lja1kxaf2I7jvKpqIffzrUb4UEHX0/lefZafE84k158P6n9rnFHqV4TLDWeW22Xl/CvOLvUiFO41xiUJLkX097E4e+GGC8ltGn64mPyOAHU5gLqwATAe0sG1JMCpH4K4qNyrc1mAc3UqC3ArGwLDONg2/yPaSiIMA4DmIQCMGaJaHtcgqqJ1U0nMrPWjACOyC24uDoArt+4VBd8ZAEkRqPwPwki6FwDiLFL7A2EngI5s0d4L2cUFnDUbBfaIge3qm0b+tSIl590WgBT1jXm2A+uvoQCINClC1wAkGqCFJP1Lhab/riIBkElSPw9BMqZm0f+hHb8rFAjQpXV/jkD5ABl8OWRGyl49YQNQieqnIUj7boAcOJoGPZz6kpwsACRVf9Mt2iG463/PMc0CAESyfjGN/4cjNe9/Zqcy5AVI1/+0sxwzyWD6UT+QgCBM17+KNPpsj/GQYRjjfwDNmOhLI8YArJMAfYxogoLyQJh+0H35Rdctoq5VRq8ngTGfTmggaAAAD6l2FHeVDmThANSuZhPBfQDUm3+YDC8750IC+jxgxPTRDeAJQCBRRS+dQhINw3B2LnEBSLd6GVtCD/0BPrYLU3p3ZkKnA0DFrx96Ewg0RTYap4LG6QKXA8ymJQxp/6bjMTkTcAUh3bf7C2HNW9c/AdgNAF2S/rEi8hckNKW+d8tifnIAiMP0I9GL3wJwlP7AdYEMqG4PBbAVoQrnAUC23I8zAbQlHLAEEM7iLgOALmKAJwDyLjAPBrBUQm02AMtSCGcDICXG4BLAbN3k2QuAlQmBJwA4lpgFAXA+gOYrAeC/B8jpAvhOAJoPQJdORKZAPRgwGZl8AKrQOKw8NSnPBoCaMvNx5VmYAcoGIMqYoPItDY82gX9pZnIBYNv51E7ZkHhPzdSR2wOIWdpZACDrBkV6GFBt68lyh8S6Ta1TCThYbbkEsO9TJxIohzer1928/eOAMlc7KwDHVj1sHgsKnD0J36olm9zAtceWMZvVMl4983qzsoTL51jkyerfIvr1wMJzXK+DrfByVmMliD6yARFiBu689LEkeDu0kgGHVqJFzr57r5wsCLYe22mj+HtuQJ0kOuTfmQMg5uBUMyPIJMLoiBN/4QDAujlcgLsA0OEEi1xQWSbvQ8W4RkFMJG4U5UpExxO8nH9ZL7G0cIx+EnqLZjWN7yasc9YDr27Y2wifTj+dV7mo2FV94A2K9cywnxEE9a0LjkQAQv0ro+MQXNcegq508qRYYAqFrQ2d4Sj11s53wYtTH4Ni8dr91VPUxWbUimBDgFFBi5noq92IE+Oj0EIFn3TE3y1/lF4tIeztrjOAEUrGreK2ASwig3Z8FEq3LWCro3fBfLYs+chnkGu5Z1YPOZV/5FL8mU/ZZzbXb3jqVfyxW/Vb2ADlHzxWl0KvrerLtzx6LUNwvX/Tw+chHeR9+v376fF7tlg8/Vje39/Pp+vRz//r2/r5/z+CAs8gm7STwwAAAABJRU5ErkJggg=="
}

export const DICE_RENEWALS_CONFIG = {
    BannerMessages: {
        Open: {
            title: 'Your renewal period is open',
            text: 'Submit a renewal form for faster & more accurate quoting up front.'
        },
        InProgress: {
            title: 'You have quotes pending',
            text: 'Please allow up to 2 -3 business days to process any change request.'
        },
        QuotesAvailable: {
            title: 'Quotes available',
            text: 'Proceed to bind online when you’re ready.'
        },
        Bound: {
            title: 'Renewal has been bound',
            text: 'Binders can be downloaded below. Please allow an additional 2-3 business days for policy packet(s) to be issued and posted online.'
        },
        Offline: {
            title: 'Your renewal is being processed offline',
            text: 'Allow up to 3-4 business days for underwriting to process your request. Any available binders can be downloaded below.'
        },
        Issued: {
            title: 'Your policies were issued',
            text: 'You can now access your policy documents through the detail page linked below. You’ll have access to this page for 5 days after your policies are issued.'
        },
        Expired: {
            title: 'Your renewal period expired',
            text: 'The renewal period has expired for the following policies. Due to lapse in coverage please contact your underwriter for options. You’ll have access to this page for 30 days from the policy expiration date.'
        },
        Blocked: {
            title: 'Referred to Underwriting',
            text: 'The following account renewal cannot be started online. To start your renewal, contact your Coaction underwriter.'
        },
        NonRenewed: {
            title: 'Non-Renewed Notice',
            text: 'The following account renewal cannot be renewed. Additional details are provided in the non-renewed notice. For more information, contact your Coaction underwriter.'
        },
        BindAndIssue: {
            title: 'Complete this form to bind and issue select quotes',
            text: 'Continue to online bind policies for the quoted lines of business. The following will be reviewed by our underwriting team for quality assurance before issuing. Please allow an additional 2-3 business days to prepare policy packet(s).'
        },
        RenewalBindError: {
            title: 'There was a problem binding the policies.',
            text: 'Something went wrong and we cannot bind the policies online. We’ll be in touch within 1-2 business days to move things forward.'
        },        
        RenewalBindDeclined: {
            title: 'Request to Decline Renewal.',
            text: 'You have chosen to decline the following policies. Your request has been sent to out underwriting team, pleasea allow 5-7 business days for this to processed.'
        },
        RenewalBindSubmitted: {
            title: 'Your bind request has been submitted.',
            text: 'A copy of the request has been emailed to you. Details regarding the status of your bind request are noted below. Any documents regarding your bind request or new policy can be found on the account’s renewal management page.'
        },
        PolicyBound: {
            title: 'Bound',
            text: 'Your policy has been bound. We’ll email you when the binder is available. Binders can also be downloaded from the account’s renewal details page.'
        },
        PolicyOffline: {
            title: 'Offline processing required.',
            text: 'This policy will be bound and issued by our underwriting team. An underwriter will be in touch if any additional information is needed within 1-2 business days.'
        },
        PolicyWCOffline: {
            title: 'Offline processing required.',
            text: 'The following declination request will be processed by our underwriting team. Please allow 1-2 business days for processing.'
        },
        PolicyDeclined: {
            title: 'Policy Renewal was declined.',
            text: 'You decided to decline the renewal for this policy for the following reason: '
        },
        PcnOrCancelled: {
            title: 'Online Renewal Unavailable',
            text: 'Renewal unavailable due to the billing status on one or more expiring policies. For more information, contact ',
            link: 'support@coactionspecialty.com'
        }
    },
    FormErrorMessages: {
        billingType: 'Billing Type is required',
        billingPaymentType: 'Please select payment type',
        DocumentRequired: "You must attach additional documents to continue."
    },
    PIMessages: {
        NoQuotes: 'No quotes available.',
        PendingCancellation: 'Renewal unavailable due to pending cancellation on expiring term',
        NonPayment: 'Renewal unavailable due to cancellation on expiring term',
        PolicyRenewalDeclined: 'Policy renewal was declined.'
    }
}

export const RenewingPolicies = [
    {
        "package": {
            question: "Are you renewing the Package Policy for another term?",
            answers: [{
                label: "Yes, renew",
                isSelected: false
            }, {
                label: "Do not renew",
                isSelected: false
            }]
        },
    }, {
    
    "wc": {
        question: "Are you renewing the Workers' Compensation Policy for another term?",
        answers: [{
            label: "Yes, renew",
            isSelected: false
        }, {
            label: "Do not renew",
            isSelected: false
        }]
    }
    }];


export const RenewalData = {    
    DONOT_RENEW_REASON : [],
    DICE_EXPOSURES_MEDIA_TYPES : [],
    
    COMPANY_NAME_REASONS : [
        { id: 1, group: RenewalGroups.COMPANY_NAME_UPDATE, type: CompanyLegalNameUpdateReason.SPELLING_CORRECTION, displayName: "Spelling Correction", isSelected: false },
        { id: 2, group: RenewalGroups.COMPANY_NAME_UPDATE, type: CompanyLegalNameUpdateReason.BUSINESS_CHANGED_NAME, displayName: "Business changed their name", isSelected: false },
        { id: 3, group: RenewalGroups.COMPANY_NAME_UPDATE, type: CompanyLegalNameUpdateReason.BUSINESS_NEW_OWNERSHIP, displayName: "Business under new ownership", isSelected: false },
        { id: 4, group: RenewalGroups.COMPANY_NAME_UPDATE, type: CompanyLegalNameUpdateReason.OTHER, displayName: "Other", isSelected: false },
    ],

    EXPOSURES: [
        {
            name: LOBType.Common,
            lobName: "",
            options: [
                {
                    keyValueID: "1",
                    shortText: "New Exposures",
                    fullText: "Does this account have any new exposures?",
                    value: "",
                    additionalInfo: "",
                    additionalInfoText: "Describe the new exposures"
                },
                {
                    keyValueID: "2",
                    shortText: "Changed Exposures",
                    fullText: "Have any exposures changed?",
                    value: "",
                    additionalInfo: "",
                    additionalInfoText: "Describe the exposure changes"
                }
            ]
        },
        {
        name: LOBType.Automobile,
        lobName: LOBTypeFullName.Automobile,
        options: [
            {
                keyValueID: "1",
                shortText: "Auto Liabililty",
                fullText: "Non-Owned Hired Auto Liability Coverage",
                value: null,                //Accept or Decline
                additionalInfo: "",
                isCurrency: false
            },
            {
                keyValueID: "2",
                shortText: "Number of Employees",
                fullText: "Number of Employees",
                value: null,
                additionalInfo: "",
                isCurrency: false
            },
            {
                keyValueID: "3",
                shortText: "Number of Partners",
                fullText: "Number of Partners",
                value: null,
                additionalInfo: "",
                isCurrency: false
            },
            {
                keyValueID: "4",
                shortText: "Estimated Cost of Hire",
                fullText: "Estimated Cost of Hire",
                value: null,
                additionalInfo: "",
                isCurrency: true
            },
            {
                keyValueID: "5",
                shortText: "UM/UIM Coverage",
                fullText: "UM/UIM Coverage",
                value: null,
                additionalInfo: "",
                isCurrency: false
            },
        ]
    },
    {
        name: LOBType.Excess_Umbrella,
        lobName: LOBTypeFullName.Excess,
        options: [
            {
                keyValueID: "1",
                shortText: "Underlying Third Party Carrier Policy",
                fullText: "Underlying Third Party Carrier Policy",
                value: null,
                additionalInfo: "",
                doesNotApplicable: false
            },
        ]
    }]
}